import React from "react"
import Cabecalho from "../Cabecalho"
import { EstrategiasFornecedorComponent } from "./components/EstrategiasFornecedorComponent"

export function EstrategiasFornecedor() {
    return (
        <>
            <Cabecalho pagina="Estratégias" />
            <EstrategiasFornecedorComponent />
        </>
    )
}
